import {
  Route,
  BrowserRouter as Router,
  Routes
} from "react-router-dom";
import HolidayCalender from "../src/components/holidayEvent/HolidayCalender";
import MaintenancePage from "../src/components/maintenance/MaintenancePage";
import LoginFormPage from "./pages/authentication/LoginFormPage";
import RegisterFormPage from "./pages/authentication/RegisterFormPage";
import ResetPasswordByEmailPage from "./pages/authentication/ResetPasswordByEmailPage";
import ResetPasswordFromProfilePage from "./pages/authentication/ResetPasswordFromProfilePage";
import ClientHistoryPage from "./pages/dashboard/ClientHistoryPage";
import ClientHomePage from "./pages/dashboard/ClientHomePage";
import ClientProfileCompletionPage from "./pages/dashboard/ClientProfileCompletionPage";
import ClientProfilePage from "./pages/dashboard/ClientProfilePage";
import ErrorPageForNonExistingURL from "./pages/error/ErrorPageForNonExistingURL";
import EmployeeInformationPage from "./pages/information/EmployeeInformationPage";
import ArchivedLeavePage from "./pages/leave/ArchivedLeavePage";
import LeavePage from "./pages/leave/LeavePage";
import NoticeListPage from "./pages/notice/NoticeListPage";
import PasswordConfirmationPage from "./pages/notifcation/PasswordConfirmationPage";
import PrivateOutlet from "./routes/PrivateOutlet";
import OrderDisplay from './components/OrderDisplay';

import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
import WorkFromHome from "./pages/wfh/WorkFromHome";
config.autoAddCss = false;

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LoginFormPage />} />
          <Route path="/login" element={<LoginFormPage />} />
          <Route path="/registration" element={<RegisterFormPage />} />
          <Route path="/order-display" element={<OrderDisplay />} />
          <Route
            path="password-recovery"
            element={<ResetPasswordByEmailPage />}
          />
          <Route
            path="/password-recovery-confirmation"
            element={
              <PasswordConfirmationPage redirectLinkAfterPasswordConfirmation="/login" />
            }
          />

          <Route path="/*" element={<PrivateOutlet />}>
            <Route path="home" element={<ClientHomePage />} />

            <Route
              path="reset-password"
              element={<ResetPasswordFromProfilePage />}
            />

            <Route path="client-profile" element={<ClientProfilePage />} />
            <Route
              path="profile-completion"
              element={<ClientProfileCompletionPage />}
            />
            <Route
              path="employee-information"
              element={<EmployeeInformationPage />}
            />
            <Route path="order-history" element={<ClientHistoryPage />} />
            <Route path="notification-list" element={<NoticeListPage />} />
            <Route path="maintenance" element={<MaintenancePage />} />
            <Route path="holiday-calender" element={<HolidayCalender />} />
            <Route path="leaves" element={<LeavePage />} />
            <Route path="wfh" element={<WorkFromHome />} />
            <Route path="archive-leaves" element={<ArchivedLeavePage />} />

            <Route path="*" element={<ErrorPageForNonExistingURL />} />
          </Route>
          <Route path="*" element={<ErrorPageForNonExistingURL />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
